<template>
  <v-app>
    <v-main>
      <v-container fluid>
        <v-row>
          <v-column class="pa-md-4">
            <search
              :mapLocationCollection="mapLocationCollection"
              @change="changeMarkerPosition"
            ></search>
          </v-column>
          <v-column>
            <l-map
              ref="map"
              class="map"
              id="map"
              :crs="crs"
              :minZoom="minZoom"
              :maxZoom="maxZoom"
              :center="getCenter"
              @click="onMapClick"
            >
              <l-image-overlay :url="url" :bounds="bounds"></l-image-overlay>
              <l-marker
                v-if="selectedMapLocation"
                :lat-lng="[selectedMapLocation.x, selectedMapLocation.y]"
                :name="selectedMapLocation.name"
              >
                <l-popup>
                  <h3>{{ selectedMapLocation.name }}</h3>
                  <p>
                      {{ selectedMapLocation.desc }}<br/>
                      <a v-if ="selectedMapLocation.url != ''" target="_blank" :href=selectedMapLocation.url>
                        Article détaillé
                      </a>
                  </p>
                </l-popup>
              </l-marker>
            </l-map>
          </v-column>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { CRS } from "leaflet";
import "leaflet/dist/leaflet.css";
import { MapLocationCollectionLoader } from "./MapLocationCollectionLoader";
import { default as dataJSON } from "../data/mapLocations.json";
import Search from "./components/Search";

import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";

// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

import { LMap, LImageOverlay, LMarker, LPopup } from "vue2-leaflet";

const mapLocationCollectionLoader = new MapLocationCollectionLoader(dataJSON);

export default {
  name: "App",
  components: {
    LMap,
    LImageOverlay,
    LMarker,
    LPopup,
    Search,
  },
  data() {
    return {
      url: "erusarden.webp",
      crs: CRS.Simple,
      bounds: [
        [0, 0],
        [2000, 3000],
      ],
      minZoom: -2,
      maxZoom: 2,
      searchString: "",
      mapLocationCollection: mapLocationCollectionLoader.load(),
      selectedMapLocation: undefined,
    };
  },
  computed: {
    getCenter() {
      if (!this.selectedMapLocation) {
        return [this.bounds[1][0] / 2, this.bounds[1][1] / 2];
      }
      return [this.selectedMapLocation.x, this.selectedMapLocation.y];
    },
  },
  mounted() {
    this.$refs.map.mapObject.fitBounds([...this.$data.bounds]);
  },
  methods: {
    changeMarkerPosition(mapLocation) {
      this.selectedMapLocation = mapLocation;
    },
    onMapClick(event) {
      console.log(event.latlng)
    }
  },
};
</script>

<style>
body {
  margin: 0px;
  padding: 0px;
}

#map {
  position: absolute;
  width: 100vw;
  height: 90vh;
  overflow: hidden;
  /* background: rgb(199, 199, 199); */
}
</style>
